import { render, staticRenderFns } from "./pafReports.vue?vue&type=template&id=48e56eda&"
import script from "./pafReports.vue?vue&type=script&lang=js&"
export * from "./pafReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports